import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Heading from "../../components/atoms/Heading";

export const AccountCreationConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name');

  return (
    <>
      <div className="container mt-2 text-center">
        <Heading h2 className="mb-2">
          Account creation confirmation
        </Heading>

        <div className="confirmation-message">          
          <div className="mb-2">
            Welcome {name}
            <br />
            Your Artetra account has now been created
          </div>

          <div className="mt-4">
            <Link 
              to="/profile" 
              style={{ textDecoration: 'none' }}
            >
              Proceed to your profile page
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
